module.exports = '1.6.1';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 122
// module chunks = 0